export enum EPhoneType {
    HOME = 'home',
    MOBILE = 'mobile',
    WORK = 'work',
    OTHER = 'other',
}

export enum EContactType {
    EMAIL = 1,
    PHONE = 2
}

export enum EContactPhoneType {
    HOME = 1,
    WORK = 2,
    MOBILE = 3,
    WHATSAPP = 4,
    OTHER = 10
}

export enum EContactCommunicationType {
    INVOICE = 1,
    NFE = 2,
    ORDER_TAP = 3,
}
